import React from 'react';
import ContactEntry from './ContactEntry/ContactEntry';

const ContactEntryRow = (props) => {
  const isNew = props.contact.Id === undefined;

  return <ContactEntry props={props} isNew={isNew} />;
};

export default ContactEntryRow;
